const charactersData = require('../Data/characters.json')

export default function GetCharactersList()
{
    return charactersData;
}